import { loginTypes } from "./constants";

//school admin login actions
export const loginRequest = (payload) => ({
  type: loginTypes.LOGIN_REQUEST,
  payload
});
export const loginSuccess = (payload) => ({
  type: loginTypes.LOGIN_SUCCESS,
  payload
});
export const loginError = (error) => ({
  type: loginTypes.LOGIN_ERROR,
  error
});
export const resetError = (error) => ({
  type: loginTypes.RESET_ERROR,
  error
});

//school admin logout actions
export const logoutRequest = (payload) => ({
  type: loginTypes.LOGOUT_REQUEST,
  payload
});
export const logoutSuccess = (payload) => ({
  type: loginTypes.LOGOUT_SUCCESS,
  payload
});
export const logoutError = (error) => ({
  type: loginTypes.LOGOUT_ERROR,
  error
});

//school admin profile actions
export const profileRequest = (payload) => ({
  type: loginTypes.PROFILE_REQUEST,
  payload
});
export const profileSuccess = (payload) => ({
  type: loginTypes.PROFILE_SUCCESS,
  payload
});
export const profileError = (error) => ({
  type: loginTypes.PROFILE_ERROR,
  error
});

// EMPLOYEE VERIFY
export const employeeVerifyRequest = (payload) => ({
  type: loginTypes.EMPLOYEE_VERIFY_REQUEST,
  payload
});

export const employeeVerifySuccess = (payload) => ({
  type: loginTypes.EMPLOYEE_VERIFY_SUCCESS,
  payload
});

export const employeeVerifyError = (error) => ({
  type: loginTypes.EMPLOYEE_VERIFY_ERROR,
  error
});

export const employErrorReset = () => ({
  type: loginTypes.EMPLOYEE_ERROR_RESET
});

// OTP VERIFY
export const otpVerifyRequest = (payload) => ({
  type: loginTypes.OTP_VERIFY_REQUEST,
  payload
});

export const otpVerifySuccess = (payload) => ({
  type: loginTypes.OTP_VERIFY_SUCCESS,
  payload
});

export const otpVerifyError = (error) => ({
  type: loginTypes.OTP_VERIFY_ERROR,
  error
});

export const otpVerifyReset = () => ({
  type: loginTypes.OTP_VERIFY_RESET
});

// RESEND OTP
export const resendOTPRequest = (payload) => ({
  type: loginTypes.RESEND_OTP_REQUEST,
  payload
});
export const resendOTPSuccess = (payload) => ({
  type: loginTypes.RESEND_OTP_SUCCESS,
  payload
});
export const resendOTPError = (error) => ({
  type: loginTypes.RESEND_OTP_ERROR,
  error
});

// REFRESH TOKEN
export const refreshTokenRequest = (payload) => ({
  type: loginTypes.REFRESH_TOKEN_REQUEST,
  payload
});
export const refreshTokenSuccess = (payload) => ({
  type: loginTypes.REFRESH_TOKEN_SUCCESS,
  payload
});
export const refreshTokenError = (error) => ({
  type: loginTypes.REFRESH_TOKEN_ERROR,
  error
});

// LOGOUT EMPLOYEE
export const logoutEmployeeRequest = () => ({
  type: loginTypes.LOGOUT_EMPLOYEE_REQUEST
});
export const logoutEmployeeSuccess = (payload) => ({
  type: loginTypes.LOGOUT_EMPLOYEE_SUCCESS,
  payload
});
export const logoutEmployeeError = (error) => ({
  type: loginTypes.LOGOUT_EMPLOYEE_ERROR,
  error
});

// EMPLOYEE DETAILS
export const getEmployeeDetailsRequest = () => ({
  type: loginTypes.GET_EMPLOYEE_DETAILS_REQUEST
});
export const getEmployeeDetailsSuccess = (payload) => ({
  type: loginTypes.GET_EMPLOYEE_DETAILS_SUCCESS,
  payload
});
export const getEmployeeDetailsError = (error) => ({
  type: loginTypes.GET_EMPLOYEE_DETAILS_ERROR,
  error
});

export const rediectingEmployee = (payload) => ({
  type: loginTypes.REDIRECTING_TYPE,
  payload
});
